import Fix from "./Fix";

export default Fix;